<template>
  <res-dialog 
    :showDialog="showDialog"
    :maxWidth="600"
    :setWidth="600"
    title="New Folder"
    titleClass="resBlue darken-1 white--text"
    iconColor="white"
    saveButtonText="CREATE FOLDER"
    :saveDisabled="isSaveDisabled"
    cancelButtonText="CANCEL"
    cancelButtonWidth="80"
    :defaultButtonAction="confirm"
    @save="confirm"
    @cancel="cancel" >
    <v-card-text>
      <div class="font-weight-500 text-center pb-4">
        {{ description }}
      </div>
      <div class="folder-input pt-5 pb-5">
        <res-text-field 
          v-model="folderName" 
          :filled="false" 
          :readonly="false" 
          placeholder="FOLDER NAME" 
          :maxLength="255">
        </res-text-field>
      </div>
    </v-card-text>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';
  import ResTextField from '@/components/base/ResTextField.vue';

  import IsNullOrWhitespaceMixin from '@/mixins/isNullOrWhitespace.js';

  export default {
    name: 'AddDocumentFolderDialog',
    components: {
      ResDialog,
      ResTextField
    },
    mixins: [IsNullOrWhitespaceMixin],
    props: {
      showDialog: {
        type: Boolean
      }
    },
    data () {
      return {
        isSaving: false,
        folderName: ''
      }
    },
    methods: {
      cancel() {
        this.isSaving = true;
        this.$emit('cancel');
      },
      confirm() {
        this.isSaving = true;
        this.$emit('save', this.folderName);
      }
    },
    computed: {
      description() {
        return "Name the folder you want to create, then select CREATE FOLDER.";
      },
      isSaveDisabled() {
        return this.isSaving || this.isNullOrWhitespace(this.folderName)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .folder-input {
    border-top: solid 1px var(--v-resGrey-lighten1);
    border-bottom: solid 1px var(--v-resGrey-lighten1);
  }
</style>